module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-600.dfce4752.eot";